import {
  MEDITATION_SESSION_TYPES,
  SESSION_TYPE_ACHIEVEMENT_MAP,
  SESSION_TYPE_LABELS,
} from '../../../services/meditationSessionTypeConstants';

export {
  MEDITATION_SESSION_TYPES,
  SESSION_TYPE_ACHIEVEMENT_MAP,
  SESSION_TYPE_LABELS,
};

/** Form select value: '' means unclassified (API null). */
export const SESSION_TYPE_UNCLASSIFIED = '';

export const SESSION_TYPE_OPTIONS = [
  {
    value: SESSION_TYPE_UNCLASSIFIED,
    label: 'Unclassified',
  },
  ...MEDITATION_SESSION_TYPES.map((value) => ({
    value,
    label: `${SESSION_TYPE_LABELS[value]} (${value})`,
  })),
];

export const SESSION_TYPE_HELPER_TEXT =
  'Classifies this session for exploration badges — it does not award a badge by itself. ' +
  `pranayama → ${SESSION_TYPE_ACHIEVEMENT_MAP.pranayama}; ` +
  `mantra → ${SESSION_TYPE_ACHIEVEMENT_MAP.mantra}; ` +
  `dhyan → ${SESSION_TYPE_ACHIEVEMENT_MAP.dhyan}; ` +
  'all three types across qualifying sessions → The Triad. ' +
  'Do not infer type from title or category.';

/** Doc/API value → form select value. */
export const sessionTypeToFormValue = (docValue) => {
  if (docValue == null || docValue === '') return SESSION_TYPE_UNCLASSIFIED;
  return String(docValue);
};

/** Form select value → API value (null or canonical enum). */
export const formValueToApiSessionType = (formValue) => {
  const v = String(formValue ?? '').trim();
  if (!v) return null;
  return v;
};

export const formatSessionTypeDisplay = (docValue) => {
  if (docValue == null || docValue === '') return 'Unclassified';
  const key = String(docValue);
  return SESSION_TYPE_LABELS[key] || key;
};

export const validateSessionTypeFormValue = (formValue) => {
  const v = String(formValue ?? '').trim();
  if (!v) return null;
  if (!MEDITATION_SESSION_TYPES.includes(v)) {
    return `session_type must be one of: ${MEDITATION_SESSION_TYPES.join(', ')}, or null`;
  }
  return null;
};

/**
 * Create: omit when unclassified (Backend defaults null); send enum when set.
 * Never send empty string (Backend rejects '').
 */
export const applySessionTypeToCreatePayload = (payload, formValue) => {
  const next = { ...payload };
  const apiValue = formValueToApiSessionType(formValue);
  if (apiValue == null) {
    delete next.session_type;
    return next;
  }
  next.session_type = apiValue;
  return next;
};

/**
 * Update semantics (Backend):
 * - omitted → preserve existing
 * - null → clear
 * - valid enum → set
 * Only include the field when the Admin intentionally changed it.
 */
export const applySessionTypeToUpdatePayload = (
  payload,
  formValue,
  previousDocValue
) => {
  const next = { ...payload };
  const apiNext = formValueToApiSessionType(formValue);
  const apiPrev =
    previousDocValue == null || previousDocValue === ''
      ? null
      : String(previousDocValue);

  if (apiNext === apiPrev) {
    delete next.session_type;
    return next;
  }
  next.session_type = apiNext;
  return next;
};
